module.exports = __webpack_public_path__ + "img/gallery_back.6e897fbd.png";